<template>
  <div class="Staff">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-card-title class="title">
              Personal inscrito en IK
              <v-spacer/>

              <v-text-field
                :disabled="dataVals.length < 0 || loading"
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer/>

              <!-- <v-card-actions>
                <v-btn color="info" :disabled="dataVals.length === 0">
                  <download-csv
                    :data=""
                    :name="''"
                    :labels=""
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions> -->

              <v-dialog v-model="dialog" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="loading"
                    color="info" dark v-on="on"
                  >
                    Nuevo Usuario
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form
                      ref="form"
                      v-model="form"
                    >
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 md7>
                            <v-text-field
                              v-model="editedUser.cedula"
                              label="Cedula*"
                              :rules="documentRules"
                              counter="40"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedUser.primer_nombre"
                              label="Primer Nombre*"
                              :rules="firstNameRules"
                              counter="20"
                              required
                            >
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedUser.segundo_nombre"
                              label="Segundo Nombre"
                              :rules="secondNameRules"
                              counter="20"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedUser.primer_apellido"
                              label="Primer Apellido*"
                              :rules="firstSurnameRules"
                              counter="20"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedUser.segundo_apellido"
                              label="Segundo Apellido"
                              :rules="secondSurnameRules"
                              counter="20"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedUser.fecha_nacimiento"
                              label="Fecha de Nacimiento"
                              type="date"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-autocomplete
                              v-model="editedUser.rh"
                              :items="rh"
                              label="Factor RH"
                            ></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-autocomplete
                              v-model="editedUser.genero"
                              :items="sexo"
                              label="Sexo"
                            ></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedUser.telefono"
                              label="Telefono"
                              :rules="phoneRules"
                              counter="15"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                      <small>* Campos obligatorios</small>
                    </v-form>
                  </v-card-text>

                  <v-alert :value="alert" type="error">
                    No se ha podido realizar la operación
                  </v-alert>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn color="info" :disabled="uploading" @click="close">Cancelar</v-btn>
                    <v-btn
                      :disabled="!form || uploading"
                      color="success"
                      @click="save"
                    >Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                :value="completed"
                color="info"
              >
                {{ progressAdvance }}
                {{ progressTotal }}
              </v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <v-data-table
                :key="tableStaffKey"
                dense
                :headers="headers"
                :items="dataVals"
                :search="search"
                no-results-text="No se encontro el término buscado"
                no-data-text="No hay datos disponibles"
                multi-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
              >
                <template slot="items" slot-scope="props">
                  <td v-for="col in columns" :key="col.id">{{ props.item[col] }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      color="info"
                      @click="editUser(props.item)"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      color="error"
                      @click="deleteUser(props.item)"
                    >
                      delete
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>

            <v-dialog v-model="dialogDelete" persistent max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Eliminar Usuario</span>
                </v-card-title>
                <v-card-text>
                  Seguro que quiere eliminar el usuario con cedula: <br>
                  <span class="title">
                    {{ editedUser.cedula }}
                  </span> <br>
                  Esta acción no se puede deshacer
                  <v-checkbox
                    v-model="checkbox"
                    label="Confirmo que deseo eliminar los datos del usuario"
                  ></v-checkbox>
                </v-card-text>

                <v-alert :value="alert" type="error">
                  No se ha podido eliminar el usuario
                </v-alert>

                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="info" :disabled="uploading" @click="close">Cancelar</v-btn>
                  <v-btn
                    color="error"
                    @click="byeUser"
                    :disabled="!checkbox || uploading"
                  >Eliminar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
// import JsonCSV from 'vue-json-csv'

export default {
  name: `Staff`,

  components: {
    // 'download-csv': JsonCSV
  },

  /** Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.getStaff()
  },

  data: function () {
    return {
      backConf: {
        pathList: '/core/users/?page=',
        pathCUD: '/core/users/', // Post sin documento demas con documento
        page: 1
      },

      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,

      loading: false,
      uploading: false,
      form: false,
      checkbox: false,

      alert: false,

      headers: [
        // {
        //   text: 'Identificador',
        //   align: 'left',
        //   value: 'id'
        // },
        // { text: 'Nombre Completo', value: 'full_name' },
        { text: 'Primer Nombre', value: 'primer_nombre', align: 'left' },
        { text: 'Segundo Nombre', value: 'segundo_nombre' },
        { text: 'Primer Apellido', value: 'primer_apellido' },
        { text: 'Segundo Apellido', value: 'segundo_apellido' },
        { text: 'Fecha Nacimiento', value: 'fecha_nacimiento' },
        { text: 'Factor RH', value: 'rh' },
        { text: 'Sexo', value: 'genero' },
        { text: 'Cédula', value: 'cedula' },
        { text: 'Teléfono', value: 'telefono' },
        { text: 'Acciones', value: '', align: 'left', sortable: false }
      ],
      dataVals: [],
      defaultUser: {
        'nombre_completo': '',
        'primer_nombre': '',
        'segundo_nombre': '',
        'primer_apellido': '',
        'segundo_apellido': '',
        'fecha_nacimiento': null,
        'rh': null,
        'genero': null,
        'cedula': '',
        'telefono': ''
      },
      tableStaffKey: 0,

      search: '',
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedUser: {
        'nombre_completo': '',
        'primer_nombre': '',
        'segundo_nombre': '',
        'primer_apellido': '',
        'segundo_apellido': '',
        'fecha_nacimiento': null,
        'rh': null,
        'genero': null,
        'cedula': '',
        'telefono': ''
      },

      rh: ['O+', 'O-', 'A+', 'A-', 'B+', 'B-', 'AB+', 'AB-'],
      sexo: [{ text: 'Femenino', value: 'F' }, { text: 'Masculino', value: 'M' }],
      documentRules: [
        v => !!v || 'Se requiere nombre de usuario',
        v => (v.length < 41) || 'Maximo 40 caracteres'
      ],
      firstNameRules: [
        v => !!v || 'Se requiere nombre de usuario',
        v => (v.length < 21) || 'Maximo 20 caracteres'
      ],
      secondNameRules: [v => (v.length < 21) || 'Maximo 20 caracteres'],
      firstSurnameRules: [
        v => !!v || 'Se requiere apellido de usuario',
        v => (v.length < 21) || 'Maximo 20 caracteres'
      ],
      secondSurnameRules: [v => (v.length < 21) || 'Maximo 20 caracteres'],
      fechaNacimientoRules: [
        v => (moment(new Date()).diff(moment(v), 'years') > 17) || 'Edad minima 18'
      ],
      phoneRules: [v => (v.length < 16) || 'Maximo 15 caracteres']
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },

    'dataVals': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  computed: {
    /** Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })

      colVals.pop() // remueve la columna final, para alinear los iconos
      return colVals
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
    }
  },

  methods: {
    /** Carga la información de todos los usuarios
     */
    getStaff () {
      this.loading = true
      let request = {
        method: 'get',
        params: {},
        url: this.backConf.pathList + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressTotal = resp.data.count
          t.progressAdvance = t.dataVals.length

          t.dataVals = t.dataVals.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.tableStaffKey += 1
            t.getStaff()
          } else {
            t.backConf.page = 1
            t.tableStaffKey += 1
            t.loading = false
          }
        })
        .catch(function (err) {
          t.dataVals = []
          t.alert = true
          t.loading = false
          t.tableStaffKey += 1
          t.backConf.page = 1
          console.error(err)
        })
    },

    /** Carga los datos del usuario seleccionado y abre el dialog
     * @param  {Object} user El usuario a editar
     */
    editUser (user) {
      this.editedIndex = this.dataVals.indexOf(user)
      this.editedUser = Object.assign({}, user)
      this.dialog = true
    },

    /** Carga los datos del usuario seleccionado y abre el dialog
     * @param  {Object} user El usuario a eliminar
     */
    deleteUser (user) {
      this.editedIndex = this.dataVals.indexOf(user)
      this.editedUser = Object.assign({}, user)
      this.dialogDelete = true
    },

    /** Elimina el usaurio seleccionado, previa confirmación
     * actualiza la tabla local
     */
    byeUser () {
      this.uploading = true
      let request = {
        method: 'delete',
        data: {},
        url: this.backConf.pathCUD + this.editedUser.cedula + '/'
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals.splice(t.editedIndex, 1)
          t.alert = false
          t.uploading = false
          t.tableStaffKey += 1
          t.close()
        })
        .catch(function (err) {
          t.alert = true
          t.uploading = false
          t.tableStaffKey += 1
          console.error(err)
        })
    },

    /** Limpia el formulario de usuario y setea el index del elemento
     */
    close () {
      this.dialog = false
      this.alert = false
      this.dialogDelete = false
      setTimeout(() => {
        this.editedUser = Object.assign({}, this.defaultUser)
        this.editedIndex = -1
      }, 300)
    },

    /** Guarda la información del usuario,
     * sea un usuario nuevo o una actualización
     * actualiza la tabla local
     */
    save () {
      this.uploading = true
      let nc = []
      nc.push(this.editedUser.primer_nombre)
      nc.push(this.editedUser.segundo_nombre)
      nc.push(this.editedUser.primer_apellido)
      nc.push(this.editedUser.segundo_apellido)
      this.editedUser.nombre_completo = nc.filter(Boolean).join(' ')

      this.alert = false

      let request = {
        method: this.editedIndex > -1 ? 'put' : 'post',
        data: this.editedUser,
        url: this.editedIndex > -1 ? this.backConf.pathCUD + this.editedUser.cedula + '/' : this.backConf.pathCUD
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          if (t.editedIndex > -1) {
            Object.assign(t.dataVals[t.editedIndex], t.editedUser)
          } else {
            t.dataVals.push(t.editedUser)
          }
          t.alert = false
          t.uploading = false
          t.tableStaffKey += 1
          t.close()
        })
        .catch(function (err) {
          t.alert = true
          t.uploading = false
          t.tableStaffKey += 1
          console.error(err)
        })
    }
  }
}
</script>
